import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type {
	DevInfoType,
	PopupOpenTrigger,
	QueryOptions,
} from '@atlassian/jira-development-board-common/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/__generated__/PRDetailsPopupViewQuery$parameters';
import type { PRDetailsPopupViewQuery } from './src/ui/__generated__/PRDetailsPopupViewQuery.graphql';

/**
 * @deprecated This component is deprecated. Please use the component from
 * "@atlassian/jira-development-board-pr-details-popup-new" package instead.
 */
export const pullRequestDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			pullRequestDetailsForIssue: PRDetailsPopupViewQuery;
		},
		{},
		{
			issueAri: string;
			devInfoType: DevInfoType;
			onReady: () => void;
			trigger?: PopupOpenTrigger;
			queryOptions?: QueryOptions;
			scopeId?: string;
		},
		{}
	>,
	{
		issueId: string;
		isNetworkOnly?: boolean;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-pr-details-popup" */ './src/ui/PRDetailsPopupView.tsx'),
	),
	getPreloadProps: ({
		issueId,
		isNetworkOnly = false,
	}: {
		issueId: string;
		isNetworkOnly?: boolean;
	}) => ({
		queries: {
			pullRequestDetailsForIssue: {
				options: {
					fetchPolicy: isNetworkOnly ? ('network-only' as const) : ('store-and-network' as const),
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
